var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NetworkStatus'),_c('Loader'),_c('router-view'),_c('PwaInstallButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }